 <template>
  <div id="lista-certificados">
    <modal />
    <b-overlay :show="show" rounded="lg">
      <p>
        Segue a relação de cursos que você atingiu a frequência
        <b>igual ou superior a 75%</b> para ter direito à emissão do
        certificado.
      </p>

      <b-table
        v-if="!vazio"
        striped
        responsive
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        table-variant="light"

      >
        <template #cell(download)="row">
          <button @click="baixar(row.item)" class="btn-download">
            <i class="fa fa-download"></i>
          </button>
        </template>
      </b-table>
      <h5 class="text-center mensagem pb-4 pt-4" v-if="vazio">
        Não encontramos cursos concluídos por você
      </h5>
      <p>
        Se não encontrou algum curso realizado, entre em contato com a
        <a
          href="http://bit.ly/redeatendimentosebraesp_presencial"
          alt="Unidades de Atendimento Sebrae São Paulo"
          target="_blank"
          >unidade que aplicou o curso</a
        >
        ou via central de atendimento pelo número <b>0800.570.0800</b>. <br />
        Para outros canais de atendimento, acesse o
        <a
          href="https://www.sebrae.com.br/sites/PortalSebrae/ufs/sp/institucional/presencial?codUf=26"
          alt="Portal Sebrae"
          >Portal Sebrae</a
        >.
      </p>
    </b-overlay>
  </div>
</template>
<script>
import axios from "axios";
import Modal from './Modal.vue'
const FileDownload = require("js-file-download");

export default {
  components: { Modal },
  name: "ListaCertificados",
  props: ["cpf"],
  methods: {
    baixar: async function (item) {
    this.show = true;
      try {
        let params = {
          idAtendimentoInscricao: item.Tipo == "P" ? item.IdAtendimento : null,
          idInscricaoKit: item.Tipo == "K" ? item.IdAtendimento : null,
        };
        let url =
          item.Tipo == "P" ? `Certificado/Gerar` : `CertificadoKit/Gerar`;

        const retorno = await axios({
          method: "get",
          url:
            `https://raeservicosfeira.sp.sebrae.com.br/RestFileManager.svc/api/` +
            url,
          params: params,
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            IdSistemaOrigem: "9970AC06-4D5F-4C36-B1D3-DA7E0CA4BCF2",
            SistemaOrigem: "Soluções Digitais",
          },
          auth: {
            username: "_solucoesdigitais",
            password: this.$props.token,
          },
          validateStatus: function () {
            return true;
          },
        });
        if (retorno.status == 200)
          FileDownload(
            retorno.data,
            "certificado-" + item.IdAtendimento + ".pdf"
          );
        else {
            this.$root.$emit('acionarModal', "Não foi possível realizar o download do certificado selecionado. Por favor, entre mais tarde ou entre em contato com nossa central de atendimento.")
        }
       this.show = false;
      } catch (error) {
        this.$root.$emit('acionarModal', `Ocorreu erro ao realizar o download do certificado ${error}`)
      }
    }
  },
  data() {
    return {
      sortBy: 'DataFim',
      sortDesc: true,
      fields: [
        {
          key: "download",
          label: "Download",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "IdAtendimento",
          label: "Inscrição",
        },
        {
          key: "Nome",
          label: "Curso",
          sortable: true,
        },

        {
          key: "DataInicio",
          formatter: (value) => {
                  return formatData(value);
           },
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "DataFim",
          formatter: (value) => {
                  return formatData(value);
           },
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "Tipo",
          thClass: "d-none",
          tdClass: "d-none",
        },
      ],
      show: false,
      vazio: false,
      token: "",
      items: [],
    };
  },
  async created() {
    this.show = true;
  },
  async mounted() {
    //Google analytics 
     this.$ga.page('/');
     let cpf = this.$props.cpf;
     cpf = cpf.length > 11 ? cpf.replace(/[^0-9]/g, "") : cpf;
    //TODO: Incluir a URL no env
    try {
        const response = await axios.get( `https://certificadoservicos.sebraesp.com.br/listar/${cpf}`);
      if(response.data.lista.length)
      {
        this.vazio = false;
        this.items = response.data.lista;
        this.$props.token = response.data.key;
        this.show = false;
      }
      else throw "Não existem certificados para emissão";
    } 
    catch(error) {
        this.vazio = true;
        this.show = false;
      }
  },
};

let formatData = (data) => {
  return (
    data.substring(8, 10) +
    "/" +
    data.substring(5, 7) +
    "/" +
    data.substring(0, 4) +
    " " +
    data.substring(11, 13) +
    ":" +
    data.substring(14, 16)
  );
};
</script>


<style scoped>
.btn-download {
  border: none;
  background-color: Transparent;
  background-repeat: no-repeat;
}

.mensagem {
  font-weight: bold;
  background-color: #dfe0e1;
}
</style>